import * as debug from 'debug';
import { DIV, SPAN } from 'sdi/components/elements';
import tr from 'sdi/locale';
import { QaMessageKey } from '../locale';

const logger = debug('qa:map-info/switch');

export const renderListSelecter = (
    title: QaMessageKey,
    current: QaMessageKey,
    list: QaMessageKey[],
    setter: (s: string) => void
) => {
    const tail = list
        .filter(s => s !== current)
        .map(s =>
            DIV(
                {
                    className: `${tr.qa(current)}-item ${s}`,
                    onClick: () => setter(s),
                },
                `${tr.qa(s)}`
            )
        );

    const head = DIV(
        { className: 'selected head' },
        SPAN({ className: 'head-label' }, tr.qa(current))
    );

    return DIV(
        { className: `issue-field ${title}`, key: `issue-field-${title}` },
        DIV({ className: 'issue-field-label' }, tr.qa(title)),
        DIV(
            {
                className: 'issue-field-value',
            },
            DIV(
                {
                    className: 'select__wrapper select',
                    onClick: e => e.currentTarget.classList.toggle('active'),
                },
                DIV(
                    { className: 'select' },
                    head,
                    DIV({ className: 'tail' }, ...tail)
                )
            )
        )
    );
};

logger('loaded');
